module.exports = __webpack_public_path__ + "img/14ne.97f28285.svg";